import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken, setAccessToken, setRefreshToken, getRefreshToken, removeAccessToken, removeRefreshToken } from './authStorage';
import { redirectToAuthLanding } from '../components/auth/authModalStorage';

const shouldRedirectToAuth = () => {
    if (window.Telegram?.WebApp?.initData) {
        return false;
    }
    const path = window.location.pathname;
    return !path.startsWith('/link-telegram') && !window.location.search.includes('auth=');
};

export const baseQueryWithReauth = (baseUrl) => async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            const token = getAccessToken();
            if (token) {
                headers.set('Content-Type', 'application/json');
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        }
    });

    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        const refreshToken = getRefreshToken();
        if (!refreshToken) {
            return result;
        }

        try {
            const refreshResult = await fetch(`${process.env.REACT_APP_AUTH_SERVICE_URL}/v1/refresh`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ refresh_token: refreshToken }),
            });

            if (refreshResult.ok) {
                const data = await refreshResult.json();
                setAccessToken(data.access_token);
                setRefreshToken(data.refresh_token);
                result = await baseQuery(args, api, extraOptions);
            } else {
                removeAccessToken();
                removeRefreshToken();

                if (shouldRedirectToAuth()) {
                    redirectToAuthLanding('login');
                }
            }
        } catch (err) {
            console.error('Token refresh error:', err);
            removeAccessToken();
            removeRefreshToken();

            if (shouldRedirectToAuth()) {
                window.location.href = '/?auth=login';
            }
        }
    }

    return result;
};
